import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import { Field, reduxForm, propTypes, formValueSelector, getFormSyncErrors, change  } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { renderFormattedField } from '../../../modules/components/formattedfield'
import { saveSeasonOilConditions, resetOilSettings, savingOilConditions } from "../../../redux/actions/seasonActions"
import { style, blue,warning, green } from '../../../utils/constants'
import SeasonHeader from './SeasonHeader'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'

const formName = 'seasonoil'
const oilTab   = 2
const colStyle = { maxWidth:'10px', padding:'10px 0 0 0' }

class OilConditions extends Component {
    static propTypes = {
        ...propTypes
    }
    constructor(props,context) {
        super(props,context)
        this.handleSaveOilConditions = this.handleSaveOilConditions.bind(this) 
        this.handleValueChange       = this.handleValueChange.bind(this)
    }
    componentDidMount(){
    }
    componentDidUpdate(){
        const {  initialize,datasaved,resetform,resetOilSettings,settingsSaved,oilreset,dispatch,resetDone } = this.props
        if (datasaved) {
            initialize({}, true)
            settingsSaved(true,oilTab)
        }    
        if(resetform == true){
            resetOilSettings()
        }
        if(oilreset == true){
            dispatch(change(formName, 'oilreset',false))
            resetDone()
        } 
    }
    handleSaveOilConditions() {
        const { saveSeasonOilConditions, conditions, settingsseason, dispatch } = this.props
        const season = conditions[settingsseason]
        const seasonoilconditions = {
            OilSportTo:season.sportTo,
            OilChallengeFrom:season.challengeFrom,
            OilChallengeTo:season.challengeTo,
            OilStandardFrom:season.standardFrom,
            seasonId:settingsseason
        }
        dispatch(savingOilConditions());
        saveSeasonOilConditions(settingsseason,seasonoilconditions)
    }
    handleValueChange() {
        const { dispatch, settingsSaved } = this.props
        dispatch(change(formName,'datasaved',false))
        settingsSaved(false,oilTab)
    }
    render(){
        const { conditions, settingsseason, savingoil,datasaved,seasonyears, syncErrors } = this.props
        const season    = `conditions[${settingsseason}]`
        const errors    =  Object.values(syncErrors)
        let isSeasonSet = true
        if(conditions) {
            isSeasonSet = conditions[settingsseason].isSeasonSet
        }

        return (
            <Row className="center-block center-text">
                <form className="form-horizontal" sm={5}  style={{ padding:'0',margin:'0' }} >
                    <Col sm={7}>
                        <FormGroup>
                            <SeasonHeader seasonyears={seasonyears} />   
                        </FormGroup>
                        { (errors.length > 0) && <ErrorList errors={errors}/> }
                        <FormGroup>
                            <label className={style.lblattrs} style={{ color:warning }}>Sport</label>
                            <Col sm={3}>
                                <label className="form-control">1.00</label> 
                            </Col> 
                            <Col sm={1} md={1} lg={2} className='text-center' style={colStyle}>to</Col>
                            <Field
                                name={`${season}.sportTo`}
                                component={renderFormattedField}
                                placeholder = '#.##'
                                inputattrs = {style.inputattr3}
                                options={style.oilfieldoptions} 
                                onChange={this.handleValueChange}                                                               
                            /> 
                        </FormGroup>
                        <FormGroup>
                            <label className={style.lblattrs} style={{ color:blue }}>Challenge</label>
                            <Field
                                name={`${season}.challengeFrom`}
                                component={renderFormattedField}
                                placeholder = '#.##'
                                inputattrs = {style.inputattr3}
                                options={style.oilfieldoptions}  
                                onChange={this.handleValueChange}                                          
                            /> 
                            <Col sm={1} md={1} lg={2} className='text-center' style={colStyle}>to</Col>
                            <Field
                                name={`${season}.challengeTo`}
                                component={renderFormattedField}
                                placeholder = '#.##'
                                inputattrs = {style.inputattr3}
                                options={style.oilfieldoptions}
                                onChange={this.handleValueChange}  
                            /> 
                        </FormGroup>
                        <FormGroup>
                            <label className={style.lblattrs} style={{ color:green }}>Standard</label>
                            <Field
                                name={`${season}.standardFrom`}
                                component={renderFormattedField}
                                placeholder = '#.##'
                                inputattrs = {style.inputattr3}
                                options={style.oilfieldoptions}
                                onChange={this.handleValueChange}
                            /> 
                            <Col sm={1}  className='text-center' style={colStyle}>to</Col>
                            <Col sm={3}>
                            <label className="form-control" style={{ minWidth:'50px' }}>&infin;</label> 
                            </Col> 
                        </FormGroup>
                        <FormGroup>
                            <Col smOffset={ 3 } sm={ 10 }>
                                <button type="button"   className="btn btn-default"  style={{ color: blue, fontWeight: 800 }} onClick={this.handleSaveOilConditions} disabled={(datasaved == undefined) || (datasaved == true)  || errors.length > 0 || !isSeasonSet}>
                                        <i className={savingoil == true? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
                                </button>
                                {
                                        datasaved && (<InfoSaved section='Season oil conditions' />)
                                }
                            </Col>
                        </FormGroup>
                    </Col>
                </form>
            </Row>
        )
    }
}
function validate(values) {
    
    const { settingsseason,conditions } = values
   
    const errors = {}
   
    if(conditions && settingsseason){
        const season = conditions[settingsseason]
        const { sportTo, challengeFrom , challengeTo, standardFrom,standardTo, isSeasonSet } = season 
        let errorCounter = 0
      
        if(isSeasonSet){         
            // check all values are provided
            if (!sportTo) {
                errors[errorCounter++] = "Sport 'to' value is required"
            }
            if (!challengeFrom) {
                errors[errorCounter++] = "Challenge 'from' value is required"
            }
            if (!challengeTo) {
                errors[errorCounter++] = "Challenge 'to' value is required"
            }
            if (!standardFrom) {
                errors[errorCounter++] = "Standard 'from' value is required"
            }
            if (!standardTo) {
                errors[errorCounter++] = "Standard 'to' value is required"
            }
            // check ranges are correct
            if(sportTo > challengeFrom){
                errors[errorCounter++] = "Sport 'to' value cannot be greater or equal to Challenge 'from' value"
            }
            if(challengeFrom > challengeTo){
                errors[errorCounter++] = "Challenge 'from' value cannot be greater or equal to Challenge 'to' value"
            }
            if(challengeTo > standardFrom){
                errors[errorCounter++] = "Challenge 'to' value cannot be greater or equal to Standard 'from' value"
            }
            // dont allow any gaps
            if((parseFloat(challengeFrom) - parseFloat(sportTo)).toFixed(2) != '0.01'){
                errors[errorCounter++] = "Cannot have gap greater than 0.01 between sport to and challenge from values"
            }
            if((parseFloat(standardFrom) - parseFloat(challengeTo)).toFixed(2) != '0.01') {
                errors[errorCounter++] = "Cannot have gap greater than 0.01 between standard from  and challenge to values"
            }   
        } 
        else {
            if( isSeasonSet != undefined  ){
                errors[errorCounter++]  = "Initiate the season by clicking 'Setup season' in the Season Dates tab"
            }
      }
    }
    return errors
} 
OilConditions.propTypes = { 
    dispatch:PropTypes.func,
    initialize:PropTypes.func,
    syncErrors:PropTypes.object,
    settingsseason:PropTypes.number,
    savingoil:PropTypes.bool,
    datasaved:PropTypes.bool,
    seasonyears:PropTypes.string,
    conditions:PropTypes.object,
    saveSeasonOilConditions: PropTypes.func,
    settingsSaved: PropTypes.func,
    resetOilSettings:PropTypes.func,
    resetform:PropTypes.bool,
    oilreset:PropTypes.bool,
    resetDone:PropTypes.func
}
function mapStateToProps(state,ownProps){
    const formName =  ownProps.form
    const selector = formValueSelector(formName)
    const settingsseason = selector(state,'settingsseason')
    const conditions     = selector(state,'conditions')
    const savingoil      = selector(state,'savingoil')
    const datasaved      = selector(state,'datasaved')
    const syncErrors     = getFormSyncErrors(formName)(state)
    const oilreset       = selector(state,'oilreset')
    return { 
        settingsseason,    
        conditions,
        savingoil,
        datasaved,
        syncErrors,
        oilreset 
    }
}
function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        saveSeasonOilConditions,
        resetOilSettings
    },dispatch)
}
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(OilConditions))




// WEBPACK FOOTER //
// ./src/containers/season/components/OilConditions.js